﻿(function () {
    "use strict";

    var app = angular.module("app");

    app.service('urlParameters', function () {
        function getUrlParams(prop) {
            var params = {};
            var search = location.href.slice(location.href.indexOf('?') + 1);
            var definitions = search.split('&');

            definitions.forEach(function (val, key) {
                var parts = decodeURIComponent(val).split('=', 2);
                params[parts[0]] = parts[1];
            });

            return (prop && prop in params) ? params[prop] : params;
        }

        return {
            get: function get(prop) {
                return getUrlParams(prop);
            }
        }
    });

    app.filter('urlEncode', function () {
        return function (input) {
            if (input) {
                return window.encodeURIComponent(input);
            }
            return "";
        }
    });

})();
